<script>
	import { Table, Col, Button } from "sveltestrap";
	import CustomPaginate from "../../../components/CustomPaginate/Pagination.svelte";
	import CustomModal from "../../../components/CustomModal/CustomModal.svelte";
	import LoaderContainer from "../../../components/Loader/LoaderContainer.svelte";
	import { navigate } from "svelte-routing";
	import { convert } from "../../../services/helpers";
	import {
		carData,
		blackoutCarData,
		carSelection,
		editBlackoutData,
		initialEditBlackout,
	} from "../../../store/store";
	import { onMount } from "svelte";

	export let data = [];

	function handleSave() {
		blackoutCarData.set($carSelection);
		if (!$editBlackoutData.stats) {
			navigate("/blackout-management/create");
		} else {
			navigate(`/blackout-management/edit/${$editBlackoutData.id}`);
			initialEditBlackout.set(1);
		}
	}

	let dataSelect = [];
	onMount(async () => {
		if ($blackoutCarData) {
			carSelection.set($blackoutCarData);
			dataSelect.push(...$blackoutCarData);
			dataSelect = dataSelect;
		}
	});

	function toSelect(id) {
		dataSelect.push(id);
		let unique = [...new Set(dataSelect)];
		return unique;
	}

	function deSelect(id) {
		dataSelect.splice(dataSelect.indexOf(id), 1);
		let unique = [...new Set(dataSelect)];

		return unique;
	}
</script>

<div class="d-flex flex-row">
	<Col class="d-flex justify-content-start mt-4 ms-2" xs={6}>
		<!-- <div class="link me-3">
			<Button
				class="themeButton btn-secondary"
				on:click={() => ($carSelection = $carData.map((x, i) => i))}
			>
				Select All
			</Button>
		</div>
		{#if $carSelection.length > 0}
			<div class="link">
				<Button
					class="themeButton btn-danger"
					on:click={() => ($carSelection = [])}
				>
					Clear
				</Button>
			</div>
		{/if} -->
		{#if $carSelection.length > 0}
			<div class="mb-2">
				<Button
					class="themeButton primary"
					on:click={() => handleSave()}>Save</Button
				>
			</div>
		{/if}
	</Col>
	<Col class="d-flex justify-content-end mt-4 ms-2" xs={6} />
</div>
<LoaderContainer>
	<Table responsive hover>
		<thead>
			<tr>
				<th
					><div class="form-check">
						<input
							type="checkbox"
							class="form-check-input"
							id="flexCheckDefaultAll"
							on:change={(e) => {
								carSelection.set(
									e.target.checked ? [...$carData] : []
								);
							}}
						/>
						<label class="form-check-label" for="flexCheckDefault1">
							All
						</label>
					</div>
				</th>

				<th>Vehicle No.</th>
				<th>Make</th>
				<th>Model</th>
				<th>Carpark</th>
				<th>Pricing Group</th>
				<th>Active Start Date</th>
				<th>Active End Date</th>
				<th>Status</th>
			</tr>
		</thead>
		<tbody>
			{#each $carData as option, index}
				<tr>
					<td class="align-center">
						<div class="form-check">
							<input
								class="form-check-input"
								type="checkbox"
								value={option}
								checked={$carSelection.some((x) => {
									if (x.id == option.id) {
										return true;
									} else {
										return false;
									}
								})}
								on:change={(e) => {
									carSelection.set(
										e.target.checked
											? toSelect(option)
											: deSelect(option)
									);
								}}
								id={`flexCheckDefault`}
							/>
						</div>
					</td>

					<td>
						<p>
							<span class="link link-text">
								{option.plateNumber}
							</span>
						</p>
					</td>
					<td>
						<p>
							<span> {option.vehicleMakeName} </span>
						</p>
					</td>
					<td>
						<p>
							<span> {option.vehicleModelName} </span>
						</p>
					</td>
					<td>
						<p>
							<span class="link link-text">
								{option.carParkName}
							</span>
						</p>
					</td>
					<td>
						<p>
							<span> {option.priceGroupName} </span>
						</p>
					</td>
					<td>
						<p>
							<span>{convert(option.activeFrom)} </span>
						</p>
					</td>
					<td>
						<p>
							<span> {convert(option.activeTo)} </span>
						</p>
					</td>
					<td>
						{#if option.status === 1}
							<p class="status-bar status-bar-1">Active</p>
						{:else if option.status === 0}
							<p class="status-bar status-bar-3">Inactive</p>
						{/if}
					</td>
				</tr>
			{/each}
		</tbody>
	</Table>
	{#if data.totalCount == 0}
		<p class="text-center">No data to display</p>
	{/if}
	<CustomPaginate totalRecord={data.totalCount} />
	<CustomModal />
</LoaderContainer>
